import { FormControl, Grid, IconButton, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import plus from "../../../../public/assets/icons/plus.svg";
import deleteIcon from "../../../../public/assets/icons/delete.svg";
import Input, { InputProps } from "@mui/material/Input";
import { CollectionNames } from "../../../queries/profileData";
import {
  CreateWorkerCollectionEntry,
  deleteWorkerCollection,
} from "../../../queries/WorkerCollectionData";
import { collectionNamesQuery } from "../../../utils/common";
import theme from "../../../theme/Theme";

const CustomInput = (props: InputProps) => {
  const inputStyle = { border: "none", outline: "none", background: "none" };

  return (
    <Input
      disableUnderline
      inputProps={{ style: inputStyle }}
      placeholder="Enter value"
      {...props}
    />
  );
};

export default CustomInput;

export const MultilineRenderer = (props: any) => {
  const [selectEnable, setSelectEnable] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const arr = props?.data?.[props?.arrayName];

  useEffect(() => {
    if (props?.objectValue === "queue" && selectEnable) {
      const profileQuery = collectionNamesQuery(props?.distributionProps?.serviceLine,props?.distributionProps?.healthSystemId)
      props?.client
        .mutate({
          mutation: CollectionNames,
          variables: {
            profileQuery: profileQuery,
          },
          // fetchPolicy: "cache-first",
        })
        .then((response: any) => {
          const data = JSON.parse(JSON.stringify(response?.data?.QueryProfile));
          const updatedOptions = data.filter((option) => {
            return !arr.some(
              (item) => item?.localCollectionId === option?.value
            );
          });
          setSelectOptions(updatedOptions);
        })
        .catch((err) => console.error(err));
    }
  }, [selectEnable]);

  const handleSelect = async (event, val) => {
    setSelectedValue(
      selectOptions?.find((option) => option.value === event.target.value)?.name
    );
    const collection = {
      max_cases: "0",
      worker_id: props?.data?.workerId,
      upstream_collection_id: event.target.value,
      type: "WORKER_COLLECTION",
      filters: [],
    };
    const options = JSON.parse(JSON.stringify(selectOptions));
    setSelectOptions(
      options.filter((option) => option?.value !== event.target.value)
    );
    props?.client
      ?.mutate({
        mutation: CreateWorkerCollectionEntry,
        variables: {
          collection,
        },
        // fetchPolicy: "cache-first",
      })
      .then((response: any) => {
        const rowNode = props.api?.getRowNode(props?.node?.id);
        const obj = {
          max_cases: 0,
          assigned_cases: 0,
          queue: val?.props?.children,
          workerCollectionId:
            response.data.CreateWorkerCollection?.data?.collection_id,
          localCollectionId:
            response.data.CreateWorkerCollection?.data?.upstream_collection_id,
        };
        const updatedData = rowNode.data;
        updatedData.queueArr = [...rowNode.data.queueArr, obj];
        rowNode?.updateData(updatedData);
        props.api.refreshCells({ rowNodes: [rowNode], force: true });
        setSelectEnable(false);
        setSelectedValue("");
      })
      .catch((err) => console.error(err));
  };

  const handleDelete = async (index) => {
    props?.client
      ?.mutate({
        mutation: deleteWorkerCollection,
        variables: {
          id: arr[index]?.workerCollectionId,
        },
        // fetchPolicy: "cache-first",
      })
      .then((response: any) => {
        const rowNode = props.api?.getRowNode(props?.node?.id);
        const updatedData = rowNode.data;
        updatedData.queueArr.splice(index, 1);
        rowNode?.updateData(updatedData);
        props.api.refreshCells({ rowNodes: [rowNode], force: true });
      })
      .catch((err) => console.error(err));
  };

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
      {props.addIcon && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            onClick={() => {
              setSelectEnable(!selectEnable);
            }}
            disableRipple={true}
            style={{
              height: "50px",
              width: "50px",
            }}
          >
            <img
              style={{ cursor: "pointer", verticalAlign: "middle" }}
              src={plus}
              alt="plus"
            />
          </IconButton>
        </div>
      )}
      <Grid container flexDirection={"row"}>
        {arr?.length
          ? arr?.map((obj, index) => (
              <Grid
                item
                container
                flexDirection={"column"}
                xs={12}
                sx={{
                  paddingLeft: "5px",
                  height: "30px",
                  justifyContent: "center",
                  alignSelf: "center",
                }}
              >
                <Grid
                  item
                  sx={{ height: "30px", display: "flex", alignItems: "center" }}
                >
                  {obj[props.objectValue]}
                </Grid>
                {props?.deleteIcon && (
                  <Grid item
                  sx={{marginLeft: "auto"}}>
                    <IconButton
                      onClick={() => {
                        handleDelete(index);
                      }}
                      disableRipple={true}
                      style={{
                        height: "50px",
                        width: "50px",
                      }}
                    >
                      <img
                        style={{ cursor: "pointer", verticalAlign: "middle" }}
                        src={deleteIcon}
                        alt="delete"
                      />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            ))
          : !selectEnable && (
              <div
                style={{
                  paddingLeft: "15px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                -
              </div>
            )}
        {selectEnable && (
          <Grid item xs={12} sx={{ width: "100%" }}>
            <FormControl sx={{ width: "100%" }}>
              <Select
                value={selectedValue}
                displayEmpty
                variant="filled"
                size="small"
                autoWidth
                onChange={(ev, val) =>
                  ev?.target?.value && handleSelect(ev, val)
                }
                renderValue={(selected) => {
                  if (selectedValue.length === 0) {
                    return (
                      <div
                        style={{ color: theme.palette.artisticTextLow.main }}
                      >
                        Select workqueue
                      </div>
                    );
                  }

                  return <div>{selectedValue}</div>;
                }}
                sx={{
                  width: "100%",
                  padding: 0,
                  marginTop: "10px",
                  height: "30px",
                  background: theme.palette.artisticStructural200.main,
                  border: "none",
                  outline: "none",
                  borderRadius: 0,
                  "& select": {
                    height: "30px",
                  },
                  "&:hover, &.Mui-focused": {
                    background: theme.palette.artisticStructural200.main,
                    padding: 0,
                    paddingTop: 0,
                  },
                  "& .MuiFilledInput-input": {
                    paddingTop: 0,
                    paddingBottom: 0,
                  },
                }}
              >
                <MenuItem disabled value="">
                  Select workqueue
                </MenuItem>
                {selectOptions?.map((option) => (
                  <MenuItem
                    key={option?.value}
                    value={option?.value}
                    sx={{ padding: "8px 16px" }}
                  >
                    {option?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
      </Grid>
    </div>
  );
};
